<style scoped lang="stylus" rel="stylesheet/stylus">
.video-uploader
  .video-box
    margin-right -8px
    display flex
    flex-wrap wrap
    .video-item
      position relative
      width 109px
      height 109px
      margin-top 8px
      margin-right 8px
      &:before
        content ''
        position absolute
        left 0
        top 0
        width 100%
        height 100%
        border inherit
        border-color #000
        border-radius inherit
        background #000
        opacity 0.1
      .control
        font-size 32px
        color #fff
        position absolute
        left 50%
        top 50%
        transform translate(-50%, -50%)
      .poster
        width 100%
        height 100%
        object-fit cover
      .deleteBtn
        position absolute
        top -13px*0.5
        right -13px*0.5
    .addBtn
      position relative
      width 109px
      height 109px
      margin-top 8px
      margin-right 8px
      background #EBECF0
      border-radius 6px
      color #969799
      .camera
        font-size 30px
        margin-bottom 7px
      .addBtnText
        font-size 12px
        line-height 18px
        text-align center
</style>

<template>
	<div class="video-uploader">
		<div class="video-box">
			<div
				v-for="(video, index) in videoList"
				class="video-item"
				@click="openVideo(video, index)"
				:key="index"
			>
				<div v-if="playingIndex === index" class="control adv-pause"></div>
				<div v-else class="control adv-play"></div>
				<img class="poster" :src="video.poster" />
				<div v-if="editable" class="deleteBtn jx-mb-cross" @click.stop="deleteVideo(index)"></div>
			</div>
			<slot name="addVideo">
				<div ref="addBtn" class="addBtn flex-col-cen-cen" v-if="addBtnShow" @click="chooseVideo">
					<span class="camera adv-playlist-1"></span>
					<div class="addBtnText">上传视频最多{{ maxUpload }}个</div>
					<input
						style="display: none;"
						:key="inputKey"
						ref="inputFile"
						type="file"
						multiple
						accept="video/*"
						@change="videoChoosed"
					/>
				</div>
			</slot>
		</div>
		<van-popup v-model="isVideoShow" :style="{ width: '100%' }" get-container="#app">
			<video-player
				class="video-player vjs-custom-skin"
				ref="videoPlayer"
				:playsinline="true"
				@pause="onPlayerPause($event)"
				@canplaythrough="onPlayerCanplaythrough($event)"
				:options="playerOptions"
			>
			</video-player>
		</van-popup>
	</div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
export default {
	name: 'video-uploader',
	inject: ['videoPoster'],
	model: {},
	props: {
		videos: {
			// 视频列表
			type: Array,
			default: () => [
				// {
				//   src: 'http://58.241.11.178:18003/mp/test.mp4',
				//   type: 'video/mp4',
				//   poster: 'https://img01.yzcdn.cn/vant/leaf.jpg'
				// }
			]
		},
		editable: {
			// 是否显示删除按钮
			type: Boolean,
			default: true
		},
		maxUpload: {
			type: Number,
			default: 3
		},
		maxFileSize: {
			type: Number,
			default: 300 // MB
		}
	},
	components: {
		videoPlayer
	},
	data() {
		return {
			inputKey: this.$common.getTimeStampId16(),
			videoList: [
				// 视频列表
				// {
				//          src: 'http://58.241.11.178:18003/mp/test.mp4',
				//          type: "video/mp4",
				//          poster: 'https://img01.yzcdn.cn/vant/leaf.jpg',
				// }
			],
			isVideoShow: false, // 是否显示视频弹窗
			playingIndex: null, // 播放中的视频索引
			playerOptions: {
				// 播放选项
				playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
				autoplay: true, // 如果为true,浏览器准备好时开始回放。
				muted: false, // 默认情况下将会消除任何音频。
				loop: false, // 是否视频一结束就重新开始。
				preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				language: 'zh-CN',
				aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				sources: [
					{
						type: 'video/mp4', // 类型
						src: '' // url地址
					}
				],
				poster: '', // 封面地址
				notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar: {
					timeDivider: true, // 当前时间和持续时间的分隔符
					durationDisplay: true, // 显示持续时间
					remainingTimeDisplay: false, // 是否显示剩余时间功能
					fullscreenToggle: true // 是否显示全屏按钮
				}
			},
			videoPath: null,
			videoImg: null,
			videoFile: null,
			videoBase64: null,
			dialog: false
		}
	},
	computed: {
		// 控制添加视频按钮显示
		addBtnShow() {
			const length = this.videoList.length
			return length < this.maxUpload
		}
	},
	created() {
		this.initData()
	},
	watch: {
		isVideoShow(newVal, oldVal) {
			if (!newVal) {
				this.$refs.videoPlayer && this.$refs.videoPlayer.player && this.$refs.videoPlayer.player.pause() // 暂停
				this.playingIndex = null
			}
		},
		videos() {
			this.initData()
		}
	},
	methods: {
		// 初始化数据
		initData() {
			const videoList = []
			this.videos.map((val, key) => {
				val.src = val.src ? val.src : ''
				// val.type = val.type ? val.type : (this.getFileType(val.src) ? 'video/' + this.getFileType(val.src) : 'video/mp4')
				val.poster = val.poster ? val.poster : ''
				videoList.push(val)
			})
			this.videoList = videoList
		},
		chooseVideo() {
			// this.$refs.inputFile.click()
			this.obtainVideo()
		},
		async videoChoosed() {
			let files = Array.from(this.$refs.inputFile.files || [])
			if (files.length <= 0) return

			files = files.slice(0, this.maxUpload - this.videoList.length)
			const maxSize = this.maxFileSize * 1024 * 1024
			const sizedFiles = files.filter(file => file.size <= maxSize)
			if (sizedFiles.length < files.length) {
				this.$notify({ type: 'warning', message: `所选文件大于${this.maxFileSize}MB` })
			}

			for (const [i, file] of Object.entries(sizedFiles)) {
				const url = URL.createObjectURL(file)
				const image = await this.videoPoster.getPoster(url, +i === sizedFiles.length - 1)
				this.videoList.push({
					file,
					src: url,
					poster: image
				})
			}
			this.refreshInput()
			this.videoChanged()
		},
		refreshInput() {
			this.inputKey = this.$common.getTimeStampId16()
		},
		// 打开视频
		openVideo(video, index) {
			// this.playerOptions.sources[0].type = video.type
			this.playerOptions.sources[0].src = video.src
			//      console.log(this.playerOptions.sources[0])
			this.playingIndex = index
			this.isVideoShow = true
			this.$refs.videoPlayer && this.$refs.videoPlayer.player && this.$refs.videoPlayer.player.play()
		},
		// 暂停回调
		onPlayerPause(player) {},
		// 加载完后执行
		onPlayerCanplaythrough() {
			this.$refs.videoPlayer && this.$refs.videoPlayer.player && this.$refs.videoPlayer.player.play()
		},
		videoChanged() {
			this.$emit('changed', this.videoList)
		},
		// 添加视频
		addVideo() {
			//      console.log('addVideo')
			this.$emit('add-video')
		},
		// 删除视频
		deleteVideo(index) {
			this.videoList.splice(index, 1)
			this.videoChanged()
			// this.$emit('delete-video', index)
		},
		// 获取文件后缀名
		getFileType(filePath) {
			var startIndex = filePath.lastIndexOf('.')
			if (startIndex !== -1) {
				return filePath.substring(startIndex + 1, filePath.length).toLowerCase()
			} else return ''
		},
		//调用video-capture插件拍摄
		obtainVideo() {
			var vuetmp = this

			//先申请读取文件权限
			var permissions = cordova.plugins.permissions
			permissions.checkPermission(
				permissions.WRITE_EXTERNAL_STORAGE,
				function(s) {
					//hasPermission 验证是否成功
					if (!s.hasPermission) {
						//没有权限
						//app申请写入权限
						permissions.requestPermission(
							permissions.WRITE_EXTERNAL_STORAGE,
							function(s) {
								if (s.hasPermission) {
									//申请成功
								} else {
									vuetmp.$toast.fail('写入权限申请失败')
								}
							},
							function(error) {}
						)
					} else {
						//拥有权限
						vuetmp.videoPath = null
						vuetmp.videoImg = null
						vuetmp.videoBase64 = null
						vuetmp.videoFile = null
						var options = { limit: 1, duration: 10 }
						//插件提供的拍视函数
						navigator.device.capture.captureVideo(vuetmp.videoCaptureSuccess, error => {}, options)
					}
				},
				function(error) {}
			)
		},
		// 拍摄成功执行转码
		videoCaptureSuccess(mediaFiles) {
			this.dialog = true
			var file = mediaFiles[0]
			alert('beforesize:' + file.size)
			var vuetmp = this
			//resolveLocalFileSystemURL()方法将接受device-absolute-path，并返回Entry
			//js无法读取安卓绝对路径，需要使用toURL()函数转换成url
			resolveLocalFileSystemURL(file.fullPath, function(entry) {
				var fileurl = entry.toURL() //如果此步转换失败检查app文件读取权限
				vuetmp.videoPath = fileurl
				// alert('9' + fileurl)
				//调用转码插件
				VideoEditor.transcodeVideo(
					vuetmp.videoTranscodeSuccess, // success cb
					vuetmp.videoTranscodeError, // error cb
					{
						fileUri: fileurl, // the path to the video on the device
						outputFileName: 'ReportVideo', // the file name for the transcoded video
						outputFileType: VideoEditorOptions.OutputFileType.mp4, // android is always mp4
						saveToLibrary: true, // optional, defaults to true
						maintainAspectRatio: true,
						deleteInputFile: false, // optional (android only), defaults to false
						width: 640, // optional, see note below on width and height
						height: 640, // optional, see notes below on width and height
						videoBitrate: 1000000, // optional, bitrate in bits, defaults to 1 megabit (1000000)
						fps: 24, // optional (android only), defaults to 24
						audioChannels: 2, // optional (ios only), number of audio channels, defaults to 2
						progress: function(info) {
							console.log('transcodeVideo progress callback, info: ' + info)
						} // info will be a number from 0 to 100
					}
				)
			})
		},
		//转码成功函数
		videoTranscodeSuccess(result) {
			this.videoPath = result
			var vuetmp = this
			//resolveLocalFileSystemURL需要传入'file:///'前缀的地址，故加上
			var resulttmp = 'file:///' + result
			resolveLocalFileSystemURL(resulttmp, function(entry) {
				entry.file(function(file) {
					var reader = new FileReader()
					reader.onloadend = function() {
						vuetmp.videoBase64 = this.result //readAsDataURL函数执行成功返回result
						// vuetmp.$emit('putFile', vuetmp.videoBase64)
						// vuetmp.dialog = false
						//生成视频缩略图
						VideoEditor.createThumbnail(vuetmp.createThumbnailSuccess, vuetmp.createThumbnailError, {
							fileUri: result,
							outputFileName: 'ReportVideoThumbnail' + vuetmp.$common.getTimeStampId16(),
							atTime: 2,
							width: 320,
							height: 480,
							quality: 100
						})
					}
					reader.readAsDataURL(file) //此函数把文件读取为Base64二进制流
					vuetmp.videoFile = file
					vuetmp.createFilePath(entry.toURL())
					vuetmp.dialog = false
				}, vuetmp.onErrorReadFile)
			})
		},
		createThumbnailSuccess(result) {
			// result is the path to the jpeg image on the device
			console.log('createThumbnailSuccess, result: ' + result)
			this.videoImg = result
			this.videoChoosed2()
		},
		onErrorReadFile(result) {
			console.log('onErrorReadFile, result: ' + result)
		},
		videoChoosed2() {
			alert('aftersize:' + this.videoFile.size)
			this.$set(this.videoList, this.videoList.length, {
				file: this.videoFile,
				src: this.videoBase64,
				poster: this.videoImg
			})
			this.refreshInput()
			this.videoChanged()
		},
		// 创建文件路径
		createFilePath(uri) {
			var _this = this
			window.requestFileSystem(
				LocalFileSystem.PERSISTENT,
				0,
				function(fs) {
					fs.root.getFile(
						'downloadVideo.mp4',
						{ create: true, exclusive: false },
						function(fileEntry) {
							// alert(fileEntry.nativeURL);
							// alert(uri)
							_this.downLoadVideo(uri, fileEntry.nativeURL)
						},
						function(err) {
							console.log(err)
						}
					)
				},
				function(error) {
					console.log(error)
				}
			)
		},
		// fileTransfer plugin
		downLoadVideo(uri, fileURL) {
			var _this = this
			// 初始化FileTransfer对象
			alert('uri:' + uri)
			var fileTransfer = new FileTransfer()
			// 调用download方法
			alert('fileURL:' + fileURL)
			fileTransfer.download(
				uri, //下载路径
				fileURL, //本地存储路径
				function(entry) {
					alert('download complete: ' + entry.toURL())
				},
				function(error) {
					console.log('download error source ' + error.source)
					console.log('download error target ' + error.target)
					console.log('upload error code' + error.code)
				}
			)
		}
	}
}
</script>
